import {createAction, createAsyncThunk, createSlice} from '@reduxjs/toolkit'
import {cpsUrl} from 'config/base'
import {getCarrierLogos} from 'services/common.service'
import {
    getAuthToken,
    getAuthTokenNew,
    getLoginDetails,
    getRefreshToken,
    signonFilter,
    updateQuickLinks,
    getMenuItemJson,
    invalidateToken,
    // publicToken,
    getLoginAttemptsDetails
} from 'services/login.service'
import {get as _get, isEmpty as _isEmpty} from 'lodash'
import {
    constructBranchMenus,
    constructCarrierMenus,
    getBranchUserFileName,
    getCarrierUserFileName,
    getServiceUserFileName
} from './login.utils'
import {authClient} from 'config/constant'
import {GuestMenus} from 'config/MenuFileNames'

export interface CarrierLogoType {
    carrier: string
    logo: string
}

export interface login {
    isLoading: boolean
    error: any
    loginDetails: any
    authToken: any
    userEmailId: any
    duplicate: any
    exists: boolean
    errorMessage: any
    isLoggedIn: boolean
    menus: object
    administrationMenu: object
    completeLogos: object
    smallLogos: object
    apiCalledDateTime: Date | null
    showLoginPopup: boolean
    navigateUrl: any
    viewScheduleData: any
    publicToken: any
    loginAttempts: any
}

const initialState: login = {
    isLoading: false,
    error: null,
    loginDetails: null,
    authToken: null,
    userEmailId: null,
    duplicate: null,
    exists: true,
    errorMessage: null,
    isLoggedIn: false,
    menus: [],
    administrationMenu: {},
    completeLogos: {},
    smallLogos: {},
    apiCalledDateTime: null,
    showLoginPopup: false,
    navigateUrl: null,
    viewScheduleData: null,
    publicToken: {},
    loginAttempts: null
}

export const fetchAuthToken = createAsyncThunk('login/fetchAuthToken', async (payload: any, {rejectWithValue}) => {
    try {
        const {passwordExpired = false} = payload
        if (localStorage.getItem('NewLogin') === 'true') {
            const {data} = await getAuthTokenNew(payload)
            if (passwordExpired) {
                const token = _get(data, 'refresh_token', '')
                if (token) {
                    const payload = {
                        // client_id: authClient.client_id,
                        // client_secret: authClient.client_secret,
                        token,
                        token_type_hint: 'refresh'
                    }
                    await invalidateToken(payload)
                }
            } else if (data?.access_token) {
                // localStorage.setItem('isLoggedIn', 'true')
                localStorage.setItem('access_token', data?.access_token)
            }
            return {data, passwordExpired}
        } else {
            const {data} = await getAuthToken(payload)
            if (data?.access_token) {
                localStorage.setItem('isLoggedIn', 'true')
                localStorage.setItem('access_token', data?.access_token)
            }
            return {data}
        }
    } catch (err: any) {
        if (err.response.status >= 400 && err.response.status < 500) {
            const msg: string =
                String(err?.response?.errors[0]?.field) + ' ' + String(err?.response?.errors[0]?.defaultMessage)
            if (localStorage.getItem('NewLogin') !== 'true') {
                window.location.href = `${cpsUrl}/lmsweb/signon.jsp`
            }
            return rejectWithValue(msg)
        } else if (err.response.status >= 500) {
            if (localStorage.getItem('NewLogin') !== 'true') {
                window.location.href = `${cpsUrl}/lmsweb/signon.jsp`
            }
            return rejectWithValue('Something went wrong')
        }
        return rejectWithValue(err.message)
    }
})

export const fetchLoginDetails = createAsyncThunk(
    'login/fetchLoginDetails',
    async (payload: any, {rejectWithValue}) => {
        try {
            const {data} = await getLoginDetails(payload)
            return data.response
        } catch (err: any) {
            if (err.response.status >= 400 && err.response.status < 500) {
                const msg: string =
                    String(err?.response?.errors[0]?.field) + ' ' + String(err?.response?.errors[0]?.defaultMessage)
                if (localStorage.getItem('NewLogin') !== 'true') {
                    window.location.href = `${cpsUrl}/lmsweb/signon.jsp`
                }
                return rejectWithValue(msg)
            } else if (err.response.status > 500) {
                if (localStorage.getItem('NewLogin') !== 'true') {
                    window.location.href = `${cpsUrl}/lmsweb/signon.jsp`
                }
                return rejectWithValue('Something went wrong')
            }
            return rejectWithValue(err.message)
        }
    }
)
export const fetchLoginAttempts = createAsyncThunk(
    'login/fetchLoginAttempts',
    async (userID: string, {rejectWithValue}) => {
        try {
            const response = await getLoginAttemptsDetails(userID)
            return response
        } catch (error: any) {
            return rejectWithValue(error.message)
        }
    }
)
export const startGuestSession = createAsyncThunk(
    'login/startGuestSession',
    async (payload: any, {rejectWithValue}) => {
        try {
            const finalStoreData = {authToken: {}, loginDetails: {}}
            const tokenPayload = {
                ...authClient,
                username: payload.businessEmailId,
                password: payload.password
            }
            const tokenResponse = await getAuthTokenNew(tokenPayload)
            const accessToken = tokenResponse?.data?.access_token
            if (accessToken) {
                localStorage.setItem('access_token', tokenResponse?.data?.access_token)
                finalStoreData.authToken = tokenResponse.data || {}
                const payloadAuth = {
                    newLogin: true,
                    headers: {
                        Authorization: `Bearer ${accessToken}`
                    }
                }
                const {data} = await getLoginDetails(payloadAuth)
                finalStoreData.loginDetails = data.response
            } else {
                return rejectWithValue('Something went wrong')
            }
            return finalStoreData
        } catch (err: any) {
            return rejectWithValue(err.message)
        }
    }
)

export const fetchEmailId = createAction<boolean>('common/setuserEmailId')

export const fetchRefreshToken = createAsyncThunk(
    'login/fetchRefreshToken',
    async (payload: any, {rejectWithValue}) => {
        try {
            const {data} = await getRefreshToken(payload)
            if (data?.response?.access_token) {
                localStorage.setItem('access_token', data?.response?.access_token)
            }
            return {data: data.response}
        } catch (err: any) {
            if (err.status >= 400 && err.status < 500) {
                const msg: string =
                    String(err?.response?.errors[0]?.field) + ' ' + String(err?.response?.errors[0]?.defaultMessage)
                return rejectWithValue(msg)
            } else if (err.status > 500) {
                return rejectWithValue('Something went wrong')
            }
            return rejectWithValue(err.message)
        }
    }
)

export const fetchSignOnFilter = createAsyncThunk(
    'login/fetchSignOnFilter',
    async (payload: any, {rejectWithValue}) => {
        try {
            const {data} = await signonFilter(payload)
            return {data: data.response}
        } catch (err: any) {
            if (err.status >= 400 && err.status < 500) {
                const msg: string =
                    String(err?.response?.errors[0]?.field) + ' ' + String(err?.response?.errors[0]?.defaultMessage)
                return rejectWithValue(msg)
            } else if (err.status > 500) {
                return rejectWithValue('Something went wrong')
            }
            return rejectWithValue(err.message)
        }
    }
)

export const fetchQuickLinks = createAsyncThunk(
    'login/fetchQuickLinks',
    async (payload: any, {dispatch, rejectWithValue}) => {
        try {
            const {data} = await updateQuickLinks(payload)
            return data.response.updatedValues
        } catch (err: any) {
            if (err.status >= 400 && err.status < 500) {
                const msg: string =
                    String(err?.response?.errors[0]?.field) + ' ' + String(err?.response?.errors[0]?.defaultMessage)
                return rejectWithValue(msg)
            } else if (err.status > 500) {
                return rejectWithValue('Something went wrong')
            }
            return rejectWithValue(err.message)
        }
    }
)

export const resetLoginLoading = createAsyncThunk(
    'login/resetLoginLoading',
    // eslint-disable-next-line
    async (payload: any) => {
        try {
            return payload
        } catch (err: any) {
            return false
        }
    }
)

export const fetchMenuItem = createAsyncThunk('login/fetchMenuItem', async (payload: any, {rejectWithValue}) => {
    try {
        const securityParams = _get(payload, 'loginDetails.securityParams', {})
        if (_isEmpty(securityParams)) {
            return rejectWithValue('Security Params are empty')
        }
        let fileName: string = ''
        const isServiceUser: boolean = _get(securityParams, 'serviceUser', false)
        const isBranchUser: boolean = _get(securityParams, 'branchUser', false)
        const isCarrierUser: boolean = _get(securityParams, 'carrierUser', false)
        const isGuestUser: boolean = _get(securityParams, 'isGuestUser', false)

        if (isGuestUser) {
            return GuestMenus
        }

        if (isServiceUser) {
            fileName = getServiceUserFileName(securityParams)
        } else if (isBranchUser) {
            fileName = getBranchUserFileName(securityParams)
        } else if (isCarrierUser) {
            fileName = getCarrierUserFileName(securityParams)
        }
        const menuGroups: object[] = await getMenuItemJson(fileName)
        menuGroups.forEach((menu: any) => {
            let subMenus = _get(menu, 'subMenus', [])
            if (!_isEmpty(subMenus)) {
                subMenus = subMenus.filter((menuItem: any) => menuItem.active)
            }
            menu.subMenus = subMenus
        })
        if (isServiceUser || isBranchUser) {
            return constructBranchMenus(menuGroups, payload, isServiceUser)
        } else if (isCarrierUser) {
            return constructCarrierMenus(menuGroups, securityParams)
        }
        return menuGroups
    } catch (err: any) {
        return rejectWithValue(err)
    }
})

const throwError = (data: any) => {
    if (!data.successFlag || typeof data === 'string') {
        throw Error(String(data.errorList).match(/text=(.*?)(?=\])/)?.[1] ?? 'Something went wrong')
    }
}

const constructLogoObject = (logo: string, carrier: string, list: object) => {
    if (!_isEmpty(logo)) {
        list[carrier] = `data:image/svg+xml;base64,${logo}`
    }
}

export const getCarrierLogosAction = createAsyncThunk('logos/carriers', async (_, {rejectWithValue}) => {
    try {
        const {data} = await getCarrierLogos()
        throwError(data)
        const completeLogos = {}
        const smallLogos = {}
        _get(data, 'response', []).forEach((item: any) => {
            constructLogoObject(item.logo, item.carrier, smallLogos)
            constructLogoObject(item.completeLogo, item.carrier, completeLogos)
        })
        return {
            completeLogos,
            smallLogos
        }
    } catch (error: any) {
        return rejectWithValue(error.message)
    }
})

export const resetLoginState = createAsyncThunk('login/resetLoginState', async (token: string, {rejectWithValue}) => {
    try {
        if (token?.trim()?.length > 0) {
            const payload = {
                // client_id: authClient.client_id,
                // client_secret: authClient.client_secret,
                token,
                token_type_hint: 'refresh'
            }
            await invalidateToken(payload)
        }
    } catch (error: any) {
        // do nothing
    }
    localStorage.removeItem('persist:root')
    return initialState
})

// export const fetchPublicToken = createAsyncThunk('login/fetchPublicToken', async () => {
//     const payload = {
//         client_id: process.env.REACT_APP_PUBLIC_CLIENT_ID,
//         grant_type: process.env.REACT_APP_PUBLIC_GRANT_TYPE,
//         client_secret: process.env.REACT_APP_PUBLIC_CLIENT_SECRET
//     }
//     try {
//         const {data} = await publicToken(payload)
//         const expiryTimeStamp = Date.now() + data.expires_in * 1000
//         return {token: data.access_token, expiryTimeStamp}
//     } catch (error: any) {
//         return error.message
//     }
// })

export const loginSlice = createSlice({
    name: 'loginDetails',
    initialState,
    reducers: {
        toggleLoginPopup: (state, action) => {
            state.showLoginPopup = action.payload
        },
        navigatePath: (state, action) => {
            state.navigateUrl = action.payload
        },
        viewScheduleValues: (state, action) => {
            state.viewScheduleData = action.payload
        }
    },
    extraReducers: function (builder) {
        builder.addCase(resetLoginState.fulfilled, (state, action) => {
            state.isLoading = false
            state.error = null
            state.loginDetails = null
            state.authToken = null
            state.userEmailId = null
            state.duplicate = null
            state.exists = true
            state.errorMessage = null
            state.isLoggedIn = false
        })
        builder.addCase(fetchSignOnFilter.pending, (state) => {
            state.isLoading = true
        })
        builder.addCase(fetchSignOnFilter.fulfilled, (state) => {
            state.isLoading = false
        })
        builder.addCase(fetchSignOnFilter.rejected, (state) => {
            state.isLoading = false
        })
        builder.addCase(fetchLoginDetails.pending, (state, action) => {
            state.isLoading = true
        })
        builder.addCase(fetchLoginDetails.fulfilled, (state, action) => {
            state.isLoading = false
            state.loginDetails = action.payload
            state.isLoggedIn = true
            state.error = null
        })
        builder.addCase(fetchLoginDetails.rejected, (state, action) => {
            state.isLoading = false
            state.loginDetails = null
            state.error = true
            state.isLoggedIn = false
        })
        builder.addCase(fetchAuthToken.pending, (state, action) => {
            state.isLoading = true
            state.error = false
        })
        builder.addCase(fetchAuthToken.fulfilled, (state, action) => {
            state.isLoading = false
            state.loginDetails = null
            if (!action.payload.passwordExpired) {
                state.authToken = action.payload
            }
            state.error = false
        })
        builder.addCase(fetchAuthToken.rejected, (state, action) => {
            state.isLoading = false
            state.authToken = null
            state.error = true
        })
        builder.addCase(startGuestSession.pending, (state, action) => {
            state.isLoading = true
            state.error = false
        })
        builder.addCase(startGuestSession.fulfilled, (state, action) => {
            state.isLoading = false
            state.loginDetails = action.payload.loginDetails
            state.authToken = action.payload.authToken
            state.isLoggedIn = true
            state.error = false
        })
        builder.addCase(startGuestSession.rejected, (state, action) => {
            state.isLoading = false
            state.authToken = null
            state.error = true
        })
        builder.addCase(fetchRefreshToken.pending, (state, action) => {
            // state.isLoading = true
        })
        builder.addCase(fetchRefreshToken.fulfilled, (state, action) => {
            state.isLoading = false
            state.authToken = action.payload
            state.error = null
        })
        builder.addCase(fetchRefreshToken.rejected, (state, action) => {
            state.isLoading = false
            state.authToken = null
            state.error = action.payload
        })
        builder.addCase(fetchQuickLinks.fulfilled, (state, action) => {
            state.loginDetails.userQuickLinks = action.payload
        })
        builder.addCase(resetLoginLoading.fulfilled, (state, action) => {
            state.isLoading = false
        })
        builder.addCase(fetchMenuItem.rejected, (state) => {
            state.menus = []
            state.administrationMenu = {}
        })
        builder.addCase(fetchMenuItem.pending, (state) => {
            state.menus = []
            state.administrationMenu = {}
        })
        builder.addCase(fetchMenuItem.fulfilled, (state, action) => {
            const index = action.payload?.length - 1
            state.administrationMenu = _get(action, `payload[${index}]`, {})
            if (action.payload?.length > 1) {
                action.payload.splice(index, 1)
                state.menus = action.payload
            } else {
                state.menus = []
            }
        })
        builder.addCase(getCarrierLogosAction.pending, (state, action) => {
            state.isLoading = true
        })
        builder.addCase(getCarrierLogosAction.fulfilled, (state, action) => {
            state.isLoading = false
            state.completeLogos = _get(action, 'payload.completeLogos', [])
            state.smallLogos = _get(action, 'payload.smallLogos', [])
            state.apiCalledDateTime = new Date()
            state.error = null
        })
        builder.addCase(getCarrierLogosAction.rejected, (state, action) => {
            state.isLoading = false
            state.error = action.payload
        })
        // builder.addCase(fetchPublicToken.pending, (state, action) => {
        //     state.isLoading = true
        // })
        // builder.addCase(fetchPublicToken.fulfilled, (state, action) => {
        //     state.isLoading = false
        //     state.publicToken = action.payload
        //     state.error = null
        // })
        // builder.addCase(fetchPublicToken.rejected, (state, action) => {
        //     state.isLoading = false
        //     state.publicToken = {}
        // })
        builder
            .addCase(fetchLoginAttempts.fulfilled, (state, action) => {
                state.loginAttempts = action.payload
            })
            .addCase(fetchLoginAttempts.rejected, (state, action) => {
                state.error = action.payload as string
            })
    }
})
export const Emailslice = createSlice({
    name: 'emailId',
    initialState,
    reducers: {},
    extraReducers: function (builder) {
        builder.addCase(fetchEmailId, (state, action) => {
            state.userEmailId = action.payload
        })
    }
})

export const {toggleLoginPopup, navigatePath, viewScheduleValues} = loginSlice.actions
export const {reducer: loginReducer} = loginSlice
export const {reducer: emailReducer} = Emailslice
